// eslint-disable-next-line import/no-anonymous-default-export
export default {
  INVITE_CUSTOMER_REQUEST: "INVITE_CUSTOMER_REQUEST",
  INVITE_CUSTOMER_SUCCESS: "INVITE_CUSTOMER_SUCCESS",
  INVITE_CUSTOMER_FAILURE: "INVITE_CUSTOMER_FAILURE",
};
